module.exports = __webpack_public_path__ + "img/insta.00e5daa5.svg";